import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import fotoPerfilDefault from '../../images/user.png';
import { Link } from "react-router-dom";
import { ApiService } from "../ApiService";

const API_url = process.env.REACT_APP_API_URL;

const ModalSearchUser = ({ isOpen, onClose, onUserSelect }) => {
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchAttempted, setSearchAttempted] = useState(false);
  const [cache, setCache] = useState({});
  const [maxResults, setMaxResults] = useState(5);

  const searchUsers = async (term) => {
    const startTime = Date.now();
    setLoading(true);

    if (cache[term]) {
      setSearchResults(cache[term]);
      setSearchAttempted(true);

      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(2000 - elapsedTime, 0);

      setTimeout(() => {
        setLoading(false);
      }, remainingTime);

      return;
    }

    try {
      const url = `api/user/search?search_user=${term}`;
      const options = { method: "GET" };

      const response = await ApiService.fetchData(url, options);

      setSearchAttempted(true);

      if (response) {
        setSearchResults(response);
        setCache((prevCache) => ({
          ...prevCache,
          [term]: response,
        }));
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error al buscar usuarios:", error);
      setSearchResults([]);
    } finally {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(2000 - elapsedTime, 0);

      setTimeout(() => {
        setLoading(false);
      }, remainingTime);
    }
  };

  const debouncedSearch = useCallback(_.debounce((term) => searchUsers(term), 500), [cache]);

  useEffect(() => {
    if (searchValue.trim().length >= 3) {
      debouncedSearch(searchValue);
      setMaxResults(5);
    } else {
      setSearchResults([]);
      setSearchAttempted(false);
    }
  }, [searchValue, debouncedSearch]);

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    setSearchAttempted(false);
  };

  const handleResultClick = (user) => {
    onUserSelect(user); // Llamar la función pasada desde el padre
    setSearchValue(""); // Limpiar el valor del input
    setSearchResults([]); // Limpiar resultados
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-search">
      <div className="modal-content-search">
        <button className="close-modal-btn" onClick={onClose}>
          ✖
        </button>
        <h3 style={{ fontSize: "22px", marginBottom: "10px" }}>Escoger Usuario</h3>

        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Buscar Usuario..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <ul>
            {searchResults.map((user) => (
              <li
                key={user.authCode}
                className="search-result-item-user"
                onClick={() => handleResultClick(user)}
              >
                <img
                  className="photo-perfil-search-user"
                  src={user.perfil ? `${API_url}${user.perfil}` : fotoPerfilDefault}
                  alt="Foto de Perfil"
                />
                <span className="text-perfil-search">{user.fullName}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModalSearchUser;
